import {
  GET_TRIBUN_COUPONS_REQUEST,
  GET_TRIBUN_COUPONS_SUCCESS,
  GET_TRIBUN_COUPONS_FAILURE,
  RESET_TRIBUN_COUPONS_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 10,
    pageIndex: 0,
    isLoadMoreButtonVisible: false
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIBUN_COUPONS_REQUEST:
      return { ...state, isFetched: false, isLoading: true, error: null };
      
    case GET_TRIBUN_COUPONS_SUCCESS:
      return {
        data: [...state.data, ...action.payload],
        pagination: action.pagination,
        isFetched: true,
        isLoading: false,
        error: null
      };

    case GET_TRIBUN_COUPONS_FAILURE:
      return {
        ...state,
        pagination: initialState.pagination,
        isFetched: true,
        isLoading: false,
        error: action.payload };

    case RESET_TRIBUN_COUPONS_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };

    default:
      return state;
  }
};
